"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGION_DICTIONARY_LNGLAT_KEY = exports.REGION_DICTIONARY_TIMEZONE_KEY = exports.REGION_DICTIONARY_NAME_KEY = exports.REGION_DICTIONARY_ID_KEY = exports.REDIS_KEY_REGIONS_METADATA_DICTIONARY = exports.isProductId = exports.PRODUCT_DICTIONARY_SUMMARY = exports.PRODUCT_DICTIONARY_COUNTRY_KEY = exports.PRODUCT_DICTIONARY_NAME_KEY = exports.PRODUCT_DICTIONARY_ID_KEY = exports.redisKeyMaker_individualProducts = exports.REDIS_KEY_PRODUCTS_DICTIONARY_ABRIDGED = void 0;
/* START OF LANDING PAGE PRODUCTS */
exports.REDIS_KEY_PRODUCTS_DICTIONARY_ABRIDGED = 'products_dictionary_abridged';
const redisKeyMaker_individualProducts = (id) => `gbp_${id}`;
exports.redisKeyMaker_individualProducts = redisKeyMaker_individualProducts;
exports.PRODUCT_DICTIONARY_ID_KEY = 'i';
exports.PRODUCT_DICTIONARY_NAME_KEY = 'n';
exports.PRODUCT_DICTIONARY_COUNTRY_KEY = 'c';
exports.PRODUCT_DICTIONARY_SUMMARY = 's';
const isProductId = (id) => /^PRO\d+(US|AU)$/.test(id);
exports.isProductId = isProductId;
/* END OF LANDING PAGE PRODUCTS */
/* START OF LANDING PAGE REGIONS */
exports.REDIS_KEY_REGIONS_METADATA_DICTIONARY = 'regions_metadata_dictionary';
exports.REGION_DICTIONARY_ID_KEY = 'i';
exports.REGION_DICTIONARY_NAME_KEY = 'n';
exports.REGION_DICTIONARY_TIMEZONE_KEY = 't';
exports.REGION_DICTIONARY_LNGLAT_KEY = 'l';
/* END OF LANDING PAGE REGIONS */
//# sourceMappingURL=landingPage.js.map